module.exports = __webpack_public_path__ + "static/media/microsoft.ecd2a7be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/microsoft.svg
// module id = 606
// module chunks = 0